<template>
  <div
    v-if="show"
    class="loader-wrapper">
    <img
      :src="srcLoader"
      :height="height"
      :width="height"
      alt="Chargement..."
      class="loader-img">
  </div>
</template>

<script>
import LOADER_CONFIG from './loader.config'

export default {
  name: 'WptvLoader',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 100
    },
    width: {
      type: Number,
      default: 100
    },
    color: {
      type: String,
      default: 'orange'
    }
  },
  computed: {
    srcLoader () {
      return `${LOADER_CONFIG.ICON_PATH}spinner-${this.color}.svg`
    }
  }
}
</script>

<style scoped lang="scss">
    .loader-wrapper {
        width: 100%;
        text-align: center;
    }
</style>
